export default function responseFetchAllServiceHistories(response: any, api: any, arg: any) {
    console.log('[API Response] All Service Histories fetched');
    console.log('[API Response] Response structure:', {
        hasData: !!response?.data,
        hasPagination: response?.pagination !== undefined
    });

    // Handle both direct array and wrapped response
    let serviceData: any[] = [];
    if (Array.isArray(response)) {
        serviceData = response;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
        // RTK Query double-wrapped: { data: { data: [...], pagination: {...} } }
        serviceData = response.data.data;
    } else if (response?.data && Array.isArray(response.data)) {
        serviceData = response.data;
    }

    console.log(`[API Response] Dispatching ${serviceData.length} service histories`);
    // For now, we return the response so the component can handle the data
    return response;
}
